import styled from "styled-components";

export const SelectorWrapper = styled.div`
    position: relative;
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 48px;
    gap: 16px;
    padding: 0 16px;
    border-radius: 8px;
    background: ${(props) => props.selectedUser ? `${props.theme.colors.celticBlue}0D` : props.theme.colors.white};
    border: ${(props) => props.selectedUser ? 'none' : `1px solid ${props.theme.colors.clearGray}`};
    width: 100%;
`;

export const AvatarWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`;

export const SelectorContentWrapper = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
    min-width: 127px;
`;

export const NameWrapper = styled.div`
    display: flex;
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: ${(props) => props.theme.fonts.size.normal};
    color: ${(props) => props.theme.colors.greyEleven};
    font-weight: bold;
`;

export const IndicatorsWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 11px;
    height: 15px;
`;

export const IndicatorItem = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 7px;
    height: 15px;
`;

export const IndicatorItemText = styled.div`
    margin: 0;
    padding: 0;
    ${(props) => props.theme.fonts.variant.light()};
    font-size: 0.75rem;
`;

export const IndicatorSeparator = styled.div`
  border-left: 2px solid ${props => props.theme.colors.clearGray};
  padding: 0 10px;
  font-size: 12px;
`;

export const RoleWrapper = styled.span`
  display: flex;
  font-size: 12px;  
  font-weight: normal;
  align-items: flex-end;
`;

export const NameRoleWrapper = styled.div`
 display: flex;
 justify-content: flex-start;
 flex-direction: row;
 align-items: flex-end;
 gap:4px;   

`

export const SelectorDropdownWrapper = styled.div`
  display: flex;
  width: 24px;
  background-color: ${(props) => props.selectedUser ? `unset` : props.theme.colors.silverGrayThree};
  rotate: ${(props) => (props.openDropdown ? "180deg" : "0deg")};
`;

export const ListWrapper = styled.div`
  position: absolute;
  top: ${(props) => props.top};
  left: 0;
  right: 0;
  background-color: ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  padding: 16px;
  display: ${(props) => (props.isVisible ? "flex" : "none")};
  flex-direction: column;
  gap: 16px;
  z-index: 3;
  max-width: 600px;
`;

export const ListItems = styled.div`
  display: flex;
  flex-direction: column;
  height: 296px;

  h3 {
    ${(props) => props.theme.fonts.variant.regular()};
    font-size: 1rem;
    color: ${(props) => props.theme.colors.darkGray};
    padding: 0;
    margin: 0 0 4px;
  }
`;

export const ListItemGroup = styled.div`
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.clearGray};
  background-color: ${(props) => props.theme.colors.primaryWhite};
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;

  p {
    width: 100%;
    ${(props) => props.theme.fonts.variant.extraLight()};
    font-size: 0.75rem;
    padding: 10px;
    text-align: center;
    margin: 0;
  }

  &::-webkit-scrollbar {
    width: 8px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.clearGray};
    border-radius: 8px;
    background-clip: content-box;
    pointer-events: none;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: ${(props) => props.theme.colors.darkGray};
  }
`;

export const ItemWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  height: 42px;
  gap: 10px;
  border-bottom: 1px solid ${(props) => props.theme.colors.silverGrayTwo};
  padding: ${(props)=> props.isTablet ? '0 8px' : '0 16px'};

  &:last-child {
    border-bottom: none;
  }

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
`;

export const ItemContent = styled.div`
  font-size: ${(props) => (props.isMobile ? "0.65rem" : props.isTablet ? '0.5625rem' : "1rem")};
  color: ${(props) => props.theme.colors.black};
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  overflow: hidden;
`;

export const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  width: 100% !important;
`;

export const CenteredModal = styled.div`
  background-color: ${(props) => props.theme.colors.highClearGray};
  border-radius: 8px;
  padding: 16px;
  width: 80%;
  max-height: 80vh;
  overflow-y: auto;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
`;


export const InputWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 10px;
    border-radius: 8px;
    border: 1px solid ${(props) => props.theme.colors.clearGray};
    background: ${(props) => props.theme.colors.primaryWhite};
    height: 48px;
    max-width: 600px;
`;

export const InputField = styled.input`
    width: 100%;
    height: 40px;
    border: none;
    outline: none;

    background: ${(props) => props.theme.colors.primaryWhite};
    ${(props) => props.theme.fonts.variant.regular()};

    ::placeholder {
        color: ${(props) => props.theme.colors.clearGray};
    }
`;

export const SearchIcon = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 20px;
    height: 20px;
`;

export const DisplayWrapper = styled(SelectorWrapper)`
  width: fit-content; 
  display: inline-flex; 
  max-width: none;
  background: ${(props) => props.selectedUser ? `${props.theme.colors.celticBlue}0D` : props.theme.colors.white};
  border: ${(props) => props.selectedUser ? 'none' : `1px solid ${props.theme.colors.clearGray}`};
`;

export const SelectedUsersWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 16px;
`;

export const SelectedUser = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 8px;
  background-color: ${(props) => props.theme.colors.mercury};
  border-radius: 100px;
  font-size: 0.875rem;
`;

export const CloseIcon = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 12px;
  height: 12px;
  &:hover {
    background-color: ${(props) => props.theme.colors.clearGray};
    border-radius: 50%;
  }
`;

export const MultiSelectorContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const UserListContainer = styled.div`
  position: absolute;
  top: 48px;
  left: 0;
  right: 0;
  width: 100%;
  z-index: 100;
`;

export const UsersLabel = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.greyEleven};
`;


export const ItemContentMulti = styled.div`
  display: flex;
  flex-direction: row;
  gap:8px;
  width: 100%;
`;

export const ItemName = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: ${props => props.theme.colors.darkGray};
`;

export const ItemDescription = styled.span`
  font-size: 14px;
  color: ${props => props.theme.colors.greyEleven};
`;


export const SelectedItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  width: 100%;
`;


export const SelectedItems = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  flex-wrap: wrap;
`;

export const SelectedItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-wrap: wrap;
`;

export const SelectedItemsLabel = styled.span`
  font-weight: 600;
  font-size: 14px;
  color: ${props => props.theme.colors.black};
`;

export const LoadingProgressWrapper = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  max-width: 600px;
  
  .MuiLinearProgress-root {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;
